module.exports = __webpack_public_path__ + "img/10.48825448.png";